import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import Chat_vue_vue_type_script_setup_true_lang_default from "./Chat.vue.script.js";
/* empty css                   */
//#region src/views/Chat/Chat.vue
var Chat_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Chat_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-6573ec87"]]);
//#endregion
export { Chat_default as default };

//# sourceMappingURL=Chat.vue.js.map